import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { KebabComponent } from '../../../components/kebab/kebab.component';

@Component({
	selector: 'formly-kabab',
	template: `<sl-kebab [entity]="to.entity" [actions]="to.actions"></sl-kebab>`,
	standalone: true,
	imports: [KebabComponent],
})
export class FormlyKababComponent extends FieldType {}
